import React, { useEffect } from 'react';
import { getPrivacyStatement } from './thunk';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../common/components/base/title/Title';
import { Typography, Container, Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactHtmlParser from 'html-react-parser';
import Theme from '../../common/constants/Theme';

const PrivacyStatement = () => {
    const statements = useSelector(state => state.privacyStatement.data.content);
    const dispatch = useDispatch();
    const theme = Theme.SECONDARY_LIGHT;

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(getPrivacyStatement());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Title title='Privacy and Security statement' subtitle=''></Title>
            <Container maxWidth='lg'>
                {
                    statements && statements.map((statements, idx) => (
                        <div key={idx}>
                            <Accordion style={{ backgroundColor: theme, marginBottom: 20, padding: 3, marginTop: 20, boxShadow: "none" }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#0E70FF' }} />}>
                                    <Typography color='primary.light' variant='title' fontFamily='BentonSansPro_Regular' >
                                        {statements.CONTENTHEADER}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography color='secondary.dark' variant='subtitle2' fontFamily='BentonSansPro_Regular'>
                                        {ReactHtmlParser(statements.CONTENTDETAIL)}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    ))
                }
            </Container>
        </div>
    );
};

export default PrivacyStatement;
